webpackJsonp([1],{

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(297);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/404',
    name: '404',
    component: __webpack_require__(274)
  }, {
    path: '*',
    redirect: '404'
  }, {
    path: '/',
    name: 'Index',
    component: __webpack_require__(277),
    meta: {
      auth: false
    }
  }, {
    path: 'opret-swop',
    name: 'CreateSwop',
    component: __webpack_require__(275),
    meta: {
      auth: false
    }
  }, {
    path: '/swop/:id',
    name: 'SingleSwop',
    component: __webpack_require__(279),
    meta: {
      auth: false
    }
  }, {
    path: '/historik',
    name: 'History',
    component: __webpack_require__(276),
    meta: {
      auth: false
    }
  }, {
    path: '/statistik',
    name: 'Stats',
    component: __webpack_require__(280),
    meta: {
      auth: false
    }
  }, {
    path: '/indstillinger',
    name: 'Settings',
    component: __webpack_require__(278),
    meta: {
      auth: false
    }
  }]
}));

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(257)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(258)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  "data-v-49eae5b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* unused harmony export remove */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return post; });
/* unused harmony export put */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__(22);



var requestsTotal = 0;
var requestCompleted = 0;
var postTotal = 0;
var postCompleted = 0;

var get = function get(path, data, cb, errorCb) {
    requestsTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.loading = true;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(path, { params: data }).then(function (response) {
        requestCompleted++;
        loading();
        cb(response);
    }).catch(function (error) {
        requestCompleted++;
        loading();
        if (errorCb !== undefined) {
            errorCb(error.response);
        }
    });
};

var remove = function remove(path, cb, errorCb) {
    requestsTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.loading = true;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(path).then(function (response) {
        requestCompleted++;
        loading();
        cb(response);
    }).catch(function (error) {
        requestCompleted++;
        loading();
        if (errorCb !== undefined) {
            errorCb(error.response);
        }
    });
};

var post = function post(path, data, cb, errorCb) {
    postTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.inputLoading = true;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(path, data).then(function (response) {
        postCompleted++;
        PostLoading();
        cb(response);
    }).catch(function (error) {
        postCompleted++;
        PostLoading();
        if (errorCb !== undefined) {
            errorCb(error.response);
        }
    });
};

var put = function put(path, data, cb, errorCb) {
    postTotal++;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.inputLoading = true;
    data['_method'] = 'PUT';
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(path, data).then(function (response) {
        postCompleted++;
        PostLoading();
        cb(response);
    }).catch(function (error) {
        postCompleted++;
        PostLoading();
        if (errorCb !== undefined) {
            errorCb(error.response);
        }
    });
};

function loading() {
    if (requestsTotal === requestCompleted) {
        requestsTotal = 0;
        requestCompleted = 0;
        __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.loading = false;
    }
}

function PostLoading() {
    if (postTotal === postCompleted) {
        postTotal = 0;
        postCompleted = 0;
        __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state.inputLoading = false;
    }
}



/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(299);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        loaded: false
    },
    modules: {}
}));

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_promise_auto__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sentry_browser__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sentry_integrations__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('placeholder-boxes', __webpack_require__(178));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('custom-alert', __webpack_require__(177));


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_seo___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = "https://swop2api.deveo.dk/api/";

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_moment___default.a);
__webpack_require__(13);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__deveodk_vue_toastr___default.a, {
    defaultPosition: 'toast-bottom-right',
    defaultType: 'info',
    defaultTimeout: 5000
});

if (true) {
    __WEBPACK_IMPORTED_MODULE_8__sentry_browser__["a" /* init */]({
        dsn: 'https://a5fb7f577b8247fa8ec1d159372fdb86@sentry.io/1536303',
        integrations: [new __WEBPACK_IMPORTED_MODULE_9__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */], attachProps: true })]
    });
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].router = __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return all; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(21);


var namespace = 'containers';

var all = function all(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};



/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return all; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(21);


var namespace = 'workers';

var all = function all(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};



/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'layout': __webpack_require__(271)
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            loginData: {
                email: '',
                password: '',
                rememberMe: true
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            return _this.$refs.username.focus();
        });
    },

    methods: {
        login: function login() {
            var _this2 = this;

            this.loading = true;
            this.$auth.login({
                url: "https://swop2api.deveo.dk/api/" + '/auth/login',
                data: this.loginData,
                rememberMe: this.rememberMe,
                fetchUser: true,
                redirect: { name: 'Index' },
                success: function success(response) {
                    _this2.$emit('loggedIn');
                    var userName = _this2.$auth.user().name;
                    _this2.$toastr('info', 'Nice to see you!', 'Welcome, ' + userName);
                    _this2.loading = false;
                },
                error: function error() {
                    _this2.$toastr('error', 'Could not login. Please check your username and password and try again.', 'Authentication failed');
                    _this2.loading = false;
                }
            });
        }
    }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['heading', 'description', 'cancelText', 'acceptText'],
    methods: {
        accept: function accept() {
            this.$emit('accept');
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title']
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    methods: {
        logout: function logout() {
            this.$auth.logout();
            this.$router.push({ name: 'Login' });
        }
    },
    computed: {
        year: function year() {
            var d = new Date();
            var year = d.getFullYear();
            return year;
        }
    }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            isOnline: true
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.updateStatus();
        this.$store.state.loaded = false;
        setTimeout(function () {
            _this.$store.state.loaded = true;
        }, 2000);
    },

    components: {
        'offline': __webpack_require__(269),
        'top-menu': __webpack_require__(273),
        'foo': __webpack_require__(270),
        'loader': __webpack_require__(272),
        'login': __webpack_require__(268)
    },
    methods: {
        updateStatus: function updateStatus() {
            if (typeof window.navigator.onLine === 'undefined') {
                this.isOnline = true;
            } else {
                this.isOnline = window.navigator.onLine;
            }
            window.addEventListener('online', this.updateStatus);
            window.addEventListener('offline', this.updateStatus);
        },
        initialize: function initialize() {
            var _this2 = this;

            console.log('hejsa');
            this.$store.state.loaded = false;
            setTimeout(function () {
                _this2.$store.state.loaded = true;
            }, 2000);
        }
    }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            userHasScrolled: false,
            progressWidth: 0,
            routes: [{
                title: 'Startside',
                name: 'Index'
            }, {
                title: 'Historik',
                name: 'History'
            }, {
                title: 'Statistik',
                name: 'Stats'
            }, {
                title: 'Indstillinger',
                name: 'Settings'
            }]
        };
    },
    created: function created() {
        window.addEventListener('scroll', this.checkScroll);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.checkScroll);
    },

    methods: {
        checkScroll: function checkScroll() {
            var scrollHeight = document.body.scrollHeight - window.innerHeight;
            var offset = window.pageYOffset;
            this.progressWidth = offset / scrollHeight * 100;
            if (window.pageYOffset > 50) {
                this.userHasScrolled = true;
            } else {
                this.userHasScrolled = false;
            }
        }
    }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_containerService__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_workerService__ = __webpack_require__(240);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            step: 1,
            containers: [],
            workers: [],
            selection: {
                serial: '',
                container: 0,
                worker: 0
            },
            showCreateAlert: false
        };
    },
    created: function created() {
        this.getContainers();
        this.getWorkers();
    },

    methods: {
        getContainers: function getContainers() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_containerService__["a" /* all */](null, function (response) {
                _this.containers = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        getWorkers: function getWorkers() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1__services_workerService__["a" /* all */](null, function (response) {
                _this2.workers = response.data;
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_swopService__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            swops: [],
            emojis: ['angry', 'dizzy', 'flushed', 'frown', 'frown-open', 'grimace', 'grin', 'grin-alt', 'grin-beam', 'grin-beam-sweat', 'grin-hearts', 'grin-squint', 'grin-squint-tears', 'grin-stars', 'grin-tears', 'grin-tongue', 'grin-tongue-squint', 'grin-tongue-wink', 'grin-wink', 'kiss', 'kiss-beam', 'kiss-wink-heart', 'laugh', 'laugh-beam', 'laugh-squint', 'laugh-wink', 'meh', 'meh-blank', 'meh-rolling-eyes', 'sad-cry', 'sad-tear', 'smile', 'smile-beam', 'smile-wink', 'surprise', 'tired']
        };
    },
    created: function created() {
        this.getSwops();
    },

    methods: {
        getSwops: function getSwops() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_swopService__["e" /* active */](null, function (response) {
                _this.swops = response.data;
                console.log(response.data);
            }, function (err) {
                console.log(err);
            });
        },
        timeFromNow: function timeFromNow(date) {
            var output = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).fromNow();
            var output1 = output.replace(' siden', '');
            var output2 = output1.replace('minutter', 'min.');
            return output2;
        }
    }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_swopService__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showTestAlert: false,
            data: null
        };
    },
    created: function created() {
        this.getSwop();
    },

    methods: {
        getSwop: function getSwop() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_swopService__["a" /* find */](this.$route.params.id, null, function (response) {
                _this.data = response.data;
                console.log(response.data);
            }, function (err) {
                console.log(err);
            });
        },
        addPart: function addPart(part) {
            var _this2 = this;

            if (!event.target.classList.contains('remove-part-btn')) {
                __WEBPACK_IMPORTED_MODULE_0__services_swopService__["b" /* addPart */](this.$route.params.id, part.id, null, function (response) {
                    console.log(response);
                    _this2.getSwop();
                });
            }
        },
        removePart: function removePart(part) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0__services_swopService__["c" /* removePart */](this.$route.params.id, part.id, null, function (response) {
                console.log(response);
                _this3.getSwop();
            });
        },
        test: function test() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_0__services_swopService__["d" /* test */](this.$route.params.id, null, function (response) {
                console.log(response);
                _this4.getSwop();
                _this4.showTestAlert = false;
            });
        },
        complete: function complete() {
            alert('Complete SWOP now');
        },
        timeFromNow: function timeFromNow(date) {
            var output = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).fromNow();
            return output;
        }
    }
});

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 41,
	"./af.js": 41,
	"./ar": 48,
	"./ar-dz": 42,
	"./ar-dz.js": 42,
	"./ar-kw": 43,
	"./ar-kw.js": 43,
	"./ar-ly": 44,
	"./ar-ly.js": 44,
	"./ar-ma": 45,
	"./ar-ma.js": 45,
	"./ar-sa": 46,
	"./ar-sa.js": 46,
	"./ar-tn": 47,
	"./ar-tn.js": 47,
	"./ar.js": 48,
	"./az": 49,
	"./az.js": 49,
	"./be": 50,
	"./be.js": 50,
	"./bg": 51,
	"./bg.js": 51,
	"./bm": 52,
	"./bm.js": 52,
	"./bn": 53,
	"./bn.js": 53,
	"./bo": 54,
	"./bo.js": 54,
	"./br": 55,
	"./br.js": 55,
	"./bs": 56,
	"./bs.js": 56,
	"./ca": 57,
	"./ca.js": 57,
	"./cs": 58,
	"./cs.js": 58,
	"./cv": 59,
	"./cv.js": 59,
	"./cy": 60,
	"./cy.js": 60,
	"./da": 13,
	"./da.js": 13,
	"./de": 63,
	"./de-at": 61,
	"./de-at.js": 61,
	"./de-ch": 62,
	"./de-ch.js": 62,
	"./de.js": 63,
	"./dv": 64,
	"./dv.js": 64,
	"./el": 65,
	"./el.js": 65,
	"./en-SG": 66,
	"./en-SG.js": 66,
	"./en-au": 67,
	"./en-au.js": 67,
	"./en-ca": 68,
	"./en-ca.js": 68,
	"./en-gb": 69,
	"./en-gb.js": 69,
	"./en-ie": 70,
	"./en-ie.js": 70,
	"./en-il": 71,
	"./en-il.js": 71,
	"./en-nz": 72,
	"./en-nz.js": 72,
	"./eo": 73,
	"./eo.js": 73,
	"./es": 76,
	"./es-do": 74,
	"./es-do.js": 74,
	"./es-us": 75,
	"./es-us.js": 75,
	"./es.js": 76,
	"./et": 77,
	"./et.js": 77,
	"./eu": 78,
	"./eu.js": 78,
	"./fa": 79,
	"./fa.js": 79,
	"./fi": 80,
	"./fi.js": 80,
	"./fo": 81,
	"./fo.js": 81,
	"./fr": 84,
	"./fr-ca": 82,
	"./fr-ca.js": 82,
	"./fr-ch": 83,
	"./fr-ch.js": 83,
	"./fr.js": 84,
	"./fy": 85,
	"./fy.js": 85,
	"./ga": 86,
	"./ga.js": 86,
	"./gd": 87,
	"./gd.js": 87,
	"./gl": 88,
	"./gl.js": 88,
	"./gom-latn": 89,
	"./gom-latn.js": 89,
	"./gu": 90,
	"./gu.js": 90,
	"./he": 91,
	"./he.js": 91,
	"./hi": 92,
	"./hi.js": 92,
	"./hr": 93,
	"./hr.js": 93,
	"./hu": 94,
	"./hu.js": 94,
	"./hy-am": 95,
	"./hy-am.js": 95,
	"./id": 96,
	"./id.js": 96,
	"./is": 97,
	"./is.js": 97,
	"./it": 99,
	"./it-ch": 98,
	"./it-ch.js": 98,
	"./it.js": 99,
	"./ja": 100,
	"./ja.js": 100,
	"./jv": 101,
	"./jv.js": 101,
	"./ka": 102,
	"./ka.js": 102,
	"./kk": 103,
	"./kk.js": 103,
	"./km": 104,
	"./km.js": 104,
	"./kn": 105,
	"./kn.js": 105,
	"./ko": 106,
	"./ko.js": 106,
	"./ku": 107,
	"./ku.js": 107,
	"./ky": 108,
	"./ky.js": 108,
	"./lb": 109,
	"./lb.js": 109,
	"./lo": 110,
	"./lo.js": 110,
	"./lt": 111,
	"./lt.js": 111,
	"./lv": 112,
	"./lv.js": 112,
	"./me": 113,
	"./me.js": 113,
	"./mi": 114,
	"./mi.js": 114,
	"./mk": 115,
	"./mk.js": 115,
	"./ml": 116,
	"./ml.js": 116,
	"./mn": 117,
	"./mn.js": 117,
	"./mr": 118,
	"./mr.js": 118,
	"./ms": 120,
	"./ms-my": 119,
	"./ms-my.js": 119,
	"./ms.js": 120,
	"./mt": 121,
	"./mt.js": 121,
	"./my": 122,
	"./my.js": 122,
	"./nb": 123,
	"./nb.js": 123,
	"./ne": 124,
	"./ne.js": 124,
	"./nl": 126,
	"./nl-be": 125,
	"./nl-be.js": 125,
	"./nl.js": 126,
	"./nn": 127,
	"./nn.js": 127,
	"./pa-in": 128,
	"./pa-in.js": 128,
	"./pl": 129,
	"./pl.js": 129,
	"./pt": 131,
	"./pt-br": 130,
	"./pt-br.js": 130,
	"./pt.js": 131,
	"./ro": 132,
	"./ro.js": 132,
	"./ru": 133,
	"./ru.js": 133,
	"./sd": 134,
	"./sd.js": 134,
	"./se": 135,
	"./se.js": 135,
	"./si": 136,
	"./si.js": 136,
	"./sk": 137,
	"./sk.js": 137,
	"./sl": 138,
	"./sl.js": 138,
	"./sq": 139,
	"./sq.js": 139,
	"./sr": 141,
	"./sr-cyrl": 140,
	"./sr-cyrl.js": 140,
	"./sr.js": 141,
	"./ss": 142,
	"./ss.js": 142,
	"./sv": 143,
	"./sv.js": 143,
	"./sw": 144,
	"./sw.js": 144,
	"./ta": 145,
	"./ta.js": 145,
	"./te": 146,
	"./te.js": 146,
	"./tet": 147,
	"./tet.js": 147,
	"./tg": 148,
	"./tg.js": 148,
	"./th": 149,
	"./th.js": 149,
	"./tl-ph": 150,
	"./tl-ph.js": 150,
	"./tlh": 151,
	"./tlh.js": 151,
	"./tr": 152,
	"./tr.js": 152,
	"./tzl": 153,
	"./tzl.js": 153,
	"./tzm": 155,
	"./tzm-latn": 154,
	"./tzm-latn.js": 154,
	"./tzm.js": 155,
	"./ug-cn": 156,
	"./ug-cn.js": 156,
	"./uk": 157,
	"./uk.js": 157,
	"./ur": 158,
	"./ur.js": 158,
	"./uz": 160,
	"./uz-latn": 159,
	"./uz-latn.js": 159,
	"./uz.js": 160,
	"./vi": 161,
	"./vi.js": 161,
	"./x-pseudo": 162,
	"./x-pseudo.js": 162,
	"./yo": 163,
	"./yo.js": 163,
	"./zh-cn": 164,
	"./zh-cn.js": 164,
	"./zh-hk": 165,
	"./zh-hk.js": 165,
	"./zh-tw": 166,
	"./zh-tw.js": 166
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 265;

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  "data-v-0fb09950",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(261)

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(293),
  /* scopeId */
  "data-v-87b029dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(259)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  "data-v-5ebecd11",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(255)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(254)
__webpack_require__(253)

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(282),
  /* scopeId */
  "data-v-1bc34b89",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(262)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  "data-v-d5ceab56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(256)

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(284),
  /* scopeId */
  "data-v-301a1469",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(263)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  "data-v-ecd77c80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(291),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(294),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(260)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  "data-v-6525190c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(290),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 281:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            Login\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "field-wrapper username"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n                    Username\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.email),
      expression: "loginData.email"
    }],
    ref: "username",
    attrs: {
      "type": "text",
      "placeholder": "Please type in your username ...",
      "name": "username",
      "id": "username"
    },
    domProps: {
      "value": (_vm.loginData.email)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field-wrapper password"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n                    Password\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Please type in your password ...",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.loginData.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "remember-me"
  }, [_c('label', {
    staticClass: "checkcontainer",
    attrs: {
      "for": "remember"
    }
  }, [_vm._v("\n                    Remember me\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.rememberMe),
      expression: "loginData.rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "name": "remember",
      "id": "remember"
    },
    domProps: {
      "checked": Array.isArray(_vm.loginData.rememberMe) ? _vm._i(_vm.loginData.rememberMe, null) > -1 : (_vm.loginData.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.loginData.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.loginData, "rememberMe", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.loginData, "rememberMe", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.loginData, "rememberMe", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("\n                    Log in\n                ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'ForgotPassword'
      }
    }
  }, [_vm._v("\n                    Forgot password?\n                ")])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "lds-ellipsis"
  }, [_c('div'), _c('div'), _c('div'), _c('div')]), _vm._v(" "), _c('div', [_vm._v("Loading")])])])
}]}

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOnline) ? _c('div', {
    staticClass: "layout"
  }, [_c('top-menu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)], 1) : _c('offline')
},staticRenderFns: []}

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notfound"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            404\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n            Whoops! Something went wrong ...\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n            We could not find what you were looking for.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_vm._v("\n                Go to homepage\n            ")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('layout')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder-boxes"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n                    " + _vm._s(_vm.title) + " Content box\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n                    " + _vm._s(_vm.title) + " Content box\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n                    " + _vm._s(_vm.title) + " Content box\n                ")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_vm._v("\n    Indstillinger\n")])
},staticRenderFns: []}

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n            " + _vm._s(_vm.year) + " © Deveo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "logout"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("\n                Log out\n                "), _c('i', {
    staticClass: "fad fa-sign-out fa-fw"
  })])])])])
},staticRenderFns: []}

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-swop bg-light"
  }, [(_vm.data) ? _c('div', [_c('div', {
    staticClass: "bg-white h-32 border-b border-solid border-gray-300 flex items-center"
  }, [_c('div', {
    staticClass: "container p-8 mx-auto"
  }, [_c('div', {
    staticClass: "md:flex md:items-center md:justify-between"
  }, [_c('div', {
    staticClass: "flex-1 min-w-0"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate"
  }, [_vm._v("\n                            " + _vm._s(_vm.data.serial) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-4 text-gray-500"
  }, [_c('div', {
    staticClass: "mr-6"
  }, [_c('i', {
    staticClass: "fas fa-box text-sm mr-1"
  }), _vm._v("\n                                " + _vm._s(_vm.data.container.name) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "mr-6"
  }, [_c('i', {
    staticClass: "fas fa-clock text-sm mr-1"
  }), _vm._v("\n                                " + _vm._s(_vm.timeFromNow(_vm.data.created_at)) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "mr-6"
  }, [_c('i', {
    staticClass: "fas fa-user text-sm mr-1"
  }), _vm._v("\n                                " + _vm._s(_vm.data.worker.name) + "\n                            ")]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-cog text-sm mr-1"
  }), _vm._v("\n                                " + _vm._s(_vm.data.parts.length) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex md:mt-0 md:ml-4"
  }, [_c('span', {
    staticClass: "hidden sm:block ml-3 shadow-sm rounded-md"
  }, [_c('button', {
    staticClass: "inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showTestAlert = true
      }
    }
  }, [_vm._v("\n                                Udfør " + _vm._s(_vm.data.tests.length + 1) + ". test\n                            ")]), _vm._v(" "), (_vm.showTestAlert) ? _c('custom-alert', {
    attrs: {
      "heading": "Er du sikker?",
      "description": 'Du er ved at udføre <b>test #' + (_vm.data.tests.length + 1) + '</b>',
      "acceptText": "Ja",
      "cancelText": "Annullér"
    },
    on: {
      "cancel": function($event) {
        _vm.showTestAlert = false
      },
      "accept": function($event) {
        return _vm.test()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "ml-3 shadow-sm rounded-md"
  }, [_c('button', {
    staticClass: "bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.complete()
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_vm._v("\n                                    Afslut SWOP\n                                ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content overflow-y-auto",
    staticStyle: {
      "height": "calc(100vh - 12rem)",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('div', {
    staticClass: "container mx-auto p-8"
  }, [(_vm.data.available_parts.length > 0) ? _c('div', {
    staticClass: "flex flex-wrap -mx-4 -mb-8"
  }, _vm._l((_vm.data.available_parts), function(part) {
    return _c('div', {
      key: part.id,
      staticClass: "h-32 w-1/3 px-4 mb-8 outline-none focus:outline-none hover:outline-none"
    }, [_c('div', {
      staticClass: "part-card cursor-pointer relative h-full flex items-center overflow-hidden bg-white shadow rounded py-4 px-6",
      class: {
        'selected': part.count > 0
      },
      on: {
        "click": function($event) {
          return _vm.addPart(part)
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "text-xl font-semibold mb-2 text-gray-900 leading-tight"
    }, [_vm._v("\n                                    " + _vm._s(part.name) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-500"
    }, [(part.count > 0) ? _c('span', [_c('span', {
      staticClass: "text-main"
    }, [_vm._v(_vm._s(part.count) + " stk")]), _vm._v(" |\n                                    ")]) : _vm._e(), _vm._v("\n                                    " + _vm._s(part.number) + "\n                                ")]), _vm._v(" "), (part.count > 0) ? _c('div', {
      staticClass: "remove-part-btn absolute bottom-0 right-0 h-10 w-16 text-sm text-white flex items-center justify-center",
      on: {
        "click": function($event) {
          return _vm.removePart(part)
        }
      }
    }, [_vm._v("\n                                    Fjern\n                                ")]) : _vm._e()])])])
  }), 0) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats"
  }, [_vm._v("\n    Statistik\n")])
},staticRenderFns: []}

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "history"
  }, [_vm._v("\n    Historik\n")])
},staticRenderFns: []}

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "x-data": "{ open: true }",
      "x-show": "open"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6",
    attrs: {
      "x-show": "open",
      "x-transition:enter": "ease-out duration-300",
      "x-transition:enter-start": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "x-transition:enter-end": "opacity-100 translate-y-0 sm:scale-100",
      "x-transition:leave": "ease-in duration-200",
      "x-transition:leave-start": "opacity-100 translate-y-0 sm:scale-100",
      "x-transition:leave-end": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mt-3 text-center sm:mt-5"
  }, [_c('h3', {
    staticClass: "text-lg leading-6 font-medium text-gray-900"
  }, [_vm._v("\n                    " + _vm._s(_vm.heading) + "\n                ")]), _vm._v(" "), (_vm.description) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('p', {
    staticClass: "text-sm leading-5 text-gray-500",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
  }, [_c('span', {
    staticClass: "flex w-full rounded-md shadow-sm sm:col-start-2"
  }, [_c('button', {
    staticClass: "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 text-base leading-6 font-medium text-white shadow-sm bg-main sm:text-sm sm:leading-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.accept()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.acceptText) + "\n                ")])]), _vm._v(" "), _c('span', {
    staticClass: "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1"
  }, [_c('button', {
    staticClass: "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.cancelText) + "\n                ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed inset-0 transition-opacity",
    attrs: {
      "x-show": "open",
      "x-transition:enter": "ease-out duration-300",
      "x-transition:enter-start": "opacity-0",
      "x-transition:enter-end": "opacity-100",
      "x-transition:leave": "ease-in duration-200",
      "x-transition:leave-start": "opacity-100",
      "x-transition:leave-end": "opacity-0"
    }
  }, [_c('div', {
    staticClass: "absolute inset-0 bg-gray-500 opacity-75"
  })])
}]}

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offline"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            Whoops!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n            You've lost the connection to the internet.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n            We could not register a live connection to the internet. Since this application uses network functions, please make sure you have a valid network connection and try again.\n        ")])])])
}]}

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index bg-light",
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('div', {
    staticClass: "bg-white h-24 border-b border-solid border-gray-300 flex items-center"
  }, [_c('div', {
    staticClass: "container p-8 mx-auto"
  }, [_c('div', {
    staticClass: "md:flex md:items-center md:justify-between"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex md:mt-0 md:ml-4"
  }, [_c('span', {
    staticClass: "ml-3 shadow-sm rounded-md"
  }, [_c('router-link', {
    staticClass: "bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white",
    attrs: {
      "tag": "button",
      "to": {
        name: 'CreateSwop'
      },
      "type": "button"
    }
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_vm._v("\n                                Opret SWOP\n                            ")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content overflow-y-auto",
    staticStyle: {
      "height": "calc(100vh - 10rem)",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('div', {
    staticClass: "container p-8 mx-auto bg-light"
  }, [(_vm.swops && _vm.swops.length > 0) ? _c('div', {
    staticClass: "flex flex-wrap -mx-4"
  }, _vm._l((_vm.swops), function(swop) {
    return _c('div', {
      key: swop.id,
      staticClass: "w-1/3 px-4 mb-8 outline-none focus:outline-none hover:outline-none"
    }, [_c('router-link', {
      staticClass: "swop-card overflow-hidden bg-white shadow rounded leading-5",
      attrs: {
        "tag": "div",
        "to": {
          name: 'SingleSwop',
          params: {
            id: swop.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "flex justify-end"
    }, [(swop.worker.color) ? _c('div', {
      staticClass: "w-full text-white py-2 px-6 text-sm text-center",
      staticStyle: {
        "background": "#ff0046"
      },
      style: ('background:' + swop.worker.color)
    }, [_vm._v("\n                                " + _vm._s(swop.worker.name) + "\n                            ")]) : _c('div', {
      staticClass: "w-full text-white py-2 px-6 text-sm text-center bg-main"
    }, [_vm._v("\n                                " + _vm._s(swop.worker.name) + "\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "inner p-4"
    }, [_c('div', {
      staticClass: "flex justify-between text-gray-500"
    }, [_c('div', [_vm._v("\n                                    ID: " + _vm._s(swop.id) + "\n                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                    " + _vm._s(_vm.timeFromNow(swop.created_at)) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-3xl text-center font-semibold my-4 text-gray-900"
    }, [_vm._v("\n                                " + _vm._s(swop.serial) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-between text-gray-500"
    }, [_c('div', [_vm._v("\n                                    " + _vm._s(swop.container.name) + "\n                                ")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "inline"
    }, [_vm._v("\n                                        " + _vm._s(swop.tests.length) + "\n                                        "), (swop.tests.length === 1) ? _c('span', [_vm._v("test")]) : _c('span', [_vm._v("tests")])])])])])])], 1)
  }), 0) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-1 min-w-0"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate"
  }, [_vm._v("\n                        Startside\n                    ")])])
}]}

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bg-main"
  }, [_c('div', {
    staticClass: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
  }, [_c('div', {
    staticClass: "flex justify-between h-16"
  }, [_c('div', {
    staticClass: "w-full flex justify-between"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hidden md:ml-6 md:flex md:items-center"
  }, _vm._l((_vm.routes), function(route) {
    return _c('router-link', {
      key: route.title,
      staticClass: "menu-item ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-white",
      class: {
        'selected': _vm.$route.name === route.name
      },
      attrs: {
        "tag": "a",
        "href": "#",
        "to": {
          name: route.name
        }
      }
    }, [_vm._v("\n                        " + _vm._s(route.title) + "\n                    ")])
  }), 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-shrink-0 flex items-center"
  }, [_c('img', {
    staticClass: "block lg:hidden h-8 w-auto",
    attrs: {
      "src": "/static/svg/logo.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hidden lg:block h-8 w-auto",
    attrs: {
      "src": "/static/svg/logo.svg",
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-swop bg-light"
  }, [_c('div', {
    staticClass: "bg-white h-24 border-b border-solid border-gray-300 flex items-center"
  }, [_c('div', {
    staticClass: "container p-8 mx-auto"
  }, [_c('div', {
    staticClass: "md:flex md:items-center md:justify-between"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex md:mt-0 md:ml-4"
  }, [(_vm.step > 1) ? _c('button', {
    staticClass: "mr-4 inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step - 1
      }
    }
  }, [_vm._v("\n                        Gå tilbage\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.step < 3) ? _c('button', {
    staticClass: "bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step + 1
      }
    }
  }, [_vm._v("\n                        Næste\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('button', {
    staticClass: "bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCreateAlert = true
      }
    }
  }, [_vm._v("\n                        Opret SWOP\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.showCreateAlert) ? _c('custom-alert', {
    attrs: {
      "heading": "Er oplysningerne korrekte?",
      "description": 'Serienummer<br><b>' + _vm.selection.serial + '</b><br><br>Beholder<br><b>' + _vm.selection.container.name + '</b><br><br>Medarbejder<br><b>' + _vm.selection.worker.name + '</b>',
      "acceptText": "Opret SWOP",
      "cancelText": "Annullér"
    },
    on: {
      "cancel": function($event) {
        _vm.showCreateAlert = false
      },
      "accept": function($event) {
        return _vm.createSwop()
      }
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content overflow-y-auto",
    staticStyle: {
      "min-height": "calc(100vh - 10rem)",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('div', {
    staticClass: "container p-8 mx-auto bg-light"
  }, [(_vm.step === 1) ? _c('div', {
    staticClass: "first-step"
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "w-1/3"
  }, [_c('div', {
    staticClass: "max-w-xs rounded-md shadow-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection.serial),
      expression: "selection.serial"
    }],
    staticClass: "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
    attrs: {
      "id": "serial",
      "placeholder": "fx VCF352XXX ...",
      "autocapitalize": "characters"
    },
    domProps: {
      "value": (_vm.selection.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selection, "serial", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "second-step"
  }, [_c('div', {
    staticClass: "text-xl font-medium mb-6"
  }, [_vm._v("\n                    2. Vælg beholder\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "containers flex flex-wrap -mx-4"
  }, _vm._l((_vm.containers), function(container) {
    return _c('div', {
      key: container.name,
      staticClass: "w-1/3 px-4 mb-4"
    }, [_c('div', {
      staticClass: "flex items-center justify-between single-container bg-white shadow p-4 rounded",
      class: {
        'selected': _vm.selection.container.id === container.id
      },
      on: {
        "click": function($event) {
          _vm.selection.container = container
        }
      }
    }, [_c('div', [_vm._v("\n                                " + _vm._s(container.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-500"
    }, [_vm._v("\n                                " + _vm._s(container.number) + "\n                            ")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "third-step"
  }, [_c('div', {
    staticClass: "text-xl font-medium mb-6"
  }, [_vm._v("\n                    3. Vælg medarbejder\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "workers flex flex-wrap -mx-4"
  }, _vm._l((_vm.workers), function(worker) {
    return _c('div', {
      key: worker.name,
      staticClass: "w-1/3 px-4 mb-4"
    }, [_c('div', {
      staticClass: "flex items-center justify-between single-worker bg-white shadow p-4 rounded",
      class: {
        'selected': _vm.selection.worker.id === worker.id
      },
      on: {
        "click": function($event) {
          _vm.selection.worker = worker
        }
      }
    }, [_c('span', [_vm._v(_vm._s(worker.name))]), _vm._v(" "), (worker.color) ? _c('div', {
      staticClass: "inline-block h-4 w-4 rounded-full mr-2",
      style: ('background:' + worker.color)
    }) : _c('div', {
      staticClass: "inline-block h-4 w-4 rounded-full bg-main mr-2"
    })])])
  }), 0)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-1 min-w-0"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate"
  }, [_vm._v("\n                        Opret SWOP\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-1/3"
  }, [_c('div', {
    staticClass: "text-xl font-medium mb-6"
  }, [_vm._v("\n                            1. Indtast serienummer\n                        ")])])
}]}

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return active; });
/* unused harmony export all */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addPart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removePart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return test; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(21);


var namespace = 'swops';

var active = function active(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */]('active-swops', params, cb, errorCb);
};

var all = function all(params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace, params, cb, errorCb);
};

var find = function find(id, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](namespace + '/' + id, params, cb, errorCb);
};

var addPart = function addPart(swopId, partId, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["b" /* post */](namespace + '/' + swopId + '/parts/' + partId, params, cb, errorCb);
};

var removePart = function removePart(swopId, partId, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["b" /* post */](namespace + '/' + swopId + '/parts/' + partId + '/remove', params, cb, errorCb);
};

var test = function test(swopId, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["b" /* post */]('swop-test/' + swopId, params, cb, errorCb);
};



/***/ })

},[238]);


// WEBPACK FOOTER //
// static/js/app.9001e7dce4ef5b4c9683.js